import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { ESwalType } from '../common/enums/index.enum';

export default class NotificationHelper {
  public static async showAwaitableSwal(
    optionsOrTitle: SweetAlertOptions | string,
    text?: string,
    buttonText?: string,
    type?: ESwalType,
  ): Promise<SweetAlertResult> {
    if(typeof optionsOrTitle === `object`) {
      return window.$swal(optionsOrTitle);
    }
    return window.$swal({
      confirmButtonText: buttonText || `OK`,
      text: text || ``,
      titleText: optionsOrTitle,
      type: type || ESwalType.INFO,
    });
  }
}
